import {z} from 'zod';

import {BaseVoidRequestSchema, BaseVoidResponseSchema} from '@dms/api/shared';

/**
 * GET
 */
export const GetWarehouseDispensingUnitPresetsRequestSchema = BaseVoidRequestSchema;
export type GetWarehouseDispensingUnitPresetsRequest = z.infer<
  typeof GetWarehouseDispensingUnitPresetsRequestSchema
>;

export const GetWarehouseDispensingUnitPresetsResponseSchema = z.array(
  z.object({
    id: z.string(),
    value: z.number(),
  })
);
export type GetWarehouseDispensingUnitPresetsResponse = z.infer<
  typeof GetWarehouseDispensingUnitPresetsResponseSchema
>;

export const GetWarehouseDispensingUnitPresetRequestSchema = z.object({
  codeListId: z.string(),
});
export type GetWarehouseDispensingUnitPresetRequest = z.infer<
  typeof GetWarehouseDispensingUnitPresetRequestSchema
>;

export const GetWarehouseDispensingUnitPresetResponseSchema = z.object({
  id: z.string(),
  value: z.number(),
});
export type GetWarehouseDispensingUnitPresetResponse = z.infer<
  typeof GetWarehouseDispensingUnitPresetResponseSchema
>;

/**
 * POST
 */
export const PostDispensingUnitPresetRequestSchema = z.object({
  value: z.number(),
});
export type PostDispensingUnitPresetRequest = z.infer<typeof PostDispensingUnitPresetRequestSchema>;

export const PostDispensingUnitPresetResponseSchema = z.object({
  id: z.string(),
  name: z.string(),
  isDefault: z.boolean(),
  isActive: z.boolean(),
});
export type PostDispensingUnitPresetResponse = z.infer<
  typeof PostDispensingUnitPresetResponseSchema
>;

/**
 * PATCH
 */
export const PatchDispensingUnitPresetRequestSchema = z.object({
  codeListId: z.string(),
  body: z.object({
    value: z.number(),
  }),
});
export type PatchDispensingUnitPresetRequest = z.infer<
  typeof PatchDispensingUnitPresetRequestSchema
>;

export const PatchDispensingUnitPresetResponseSchema = BaseVoidResponseSchema;
export type PatchDispensingUnitPresetResponse = z.infer<
  typeof PatchDispensingUnitPresetResponseSchema
>;

/**
 * DELETE
 */
export const DeleteDispensingUnitPresetsRequestSchema = z.object({
  codelistIds: z.array(z.string()),
});
export type DeleteDispensingUnitPresetsRequest = z.infer<
  typeof DeleteDispensingUnitPresetsRequestSchema
>;

export const DeleteDispensingUnitPresetsResponseSchema = BaseVoidResponseSchema;
export type DeleteDispensingUnitPresetsResponse = z.infer<
  typeof DeleteDispensingUnitPresetsResponseSchema
>;
